/**
 * `/onboarding` — l'onboarding in due tratti: la creazione di una nuova azienda (solo superadmin) e
 * la lista di controllo del tenant corrente. La pagina vive in `src/features/onboarding/`.
 *
 * Due segnali nella query, letti dal wizard e poi tolti dall'indirizzo:
 * - `nuova=1` apre subito la creazione — è dove atterra il vecchio `/setup`;
 * - `creata=1` dice che si arriva dalla creazione appena conclusa, e il wizard lo dice.
 */
import { createFileRoute } from '@tanstack/react-router';
import { OnboardingWizard } from '@/features/onboarding/OnboardingWizard';

export interface OnboardingSearch {
  new?: boolean;
  created?: boolean;
}

const isTruthy = (v: unknown) => v === true || v === 1 || v === '1' || v === 'true';

export const Route = createFileRoute('/_app/onboarding')({
  validateSearch: (s: Record<string, unknown>): OnboardingSearch => ({
    new: isTruthy(s.nuova) ? true : undefined,
    created: isTruthy(s.creata) ? true : undefined,
  }),
  component: OnboardingWizard,
});
